/*! Trendora v1.0.0 | (c) Vilomarket | vilomarket.com | assets/predictive-search.js */
/* =========================================================
   predictive search
   Author: Vilomarket
   ========================================================= */
(function () {
  'use strict';

  var Trendora = window.Trendora || {};
  var routes = Trendora.routes || {};
  var settings = Trendora.settings || {};

  if (!settings.predictiveSearch) return;

  var MIN_LENGTH = 2;
  var controller = null;

  function parseHTML(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function close(wrapper) {
    var results = wrapper.querySelector('[data-predictive-results]');
    var input = wrapper.querySelector('[data-search-input]');
    if (results) {
      results.hidden = true;
      results.innerHTML = '';
    }
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  function announce(wrapper, message) {
    var status = wrapper.querySelector('[data-predictive-status]');
    if (status) status.textContent = message;
  }

  function search(wrapper, term) {
    var results = wrapper.querySelector('[data-predictive-results]');
    if (!results) return;

    if (controller) controller.abort();
    controller = new AbortController();

    var base = routes.predictiveSearch || '/search/suggest';
    var params =
      '?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product,collection,page,article' +
      '&resources[limit]=5' +
      '&section_id=predictive-search';

    fetch(base + params, { signal: controller.signal })
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response);
      })
      .then(function (text) {
        var fresh = parseHTML(text);
        var source = fresh.querySelector('#shopify-section-predictive-search') || fresh.body;

        results.innerHTML = source.innerHTML;
        results.hidden = false;

        var input = wrapper.querySelector('[data-search-input]');
        if (input) input.setAttribute('aria-expanded', 'true');

        announce(wrapper, results.querySelectorAll('.predictive-search__item').length + '');
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        close(wrapper);
      });
  }

  var run = debounce(function (wrapper, term) {
    search(wrapper, term);
  }, 250);

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!(input instanceof Element) || !input.matches('[data-search-input]')) return;

    var wrapper = input.closest('[data-predictive-search]');
    if (!wrapper) return;

    var term = input.value.trim();
    if (term.length < MIN_LENGTH) {
      close(wrapper);
      return;
    }

    run(wrapper, term);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

    var wrapper = event.target instanceof Element ? event.target.closest('[data-predictive-search]') : null;
    if (!wrapper) return;

    var items = Array.prototype.slice.call(wrapper.querySelectorAll('.predictive-search__item'));
    if (!items.length) return;

    event.preventDefault();
    var current = items.indexOf(document.activeElement);
    var next = event.key === 'ArrowDown' ? current + 1 : current - 1;

    if (next < 0) next = items.length - 1;
    if (next >= items.length) next = 0;

    items[next].focus();
  });

  document.addEventListener('click', function (event) {
    var wrapper = event.target instanceof Element ? event.target.closest('[data-predictive-search]') : null;
    if (wrapper) return;

    document.querySelectorAll('[data-predictive-search]').forEach(close);
  });
})();
